import clsx from "clsx";
import { useMove } from "@react-aria/interactions";
import { useRef, useState } from "react";

import styles from "./sidebar-page.module.css";

interface SidebarPageProps {
  "data-testid"?: string;
  contentType?: "table" | "form";
  sidebar: React.ReactNode;
  children: React.ReactNode;
}

function SidebarPage({
  "data-testid": testId = "pallet-sidebar-page",
  contentType = "table",
  children,
  sidebar,
}: SidebarPageProps) {
  const [sidebarWidth, setWidth] = useState(300);
  const sidebarRef = useRef<HTMLDivElement>(null);

  const { moveProps } = useMove({
    onMove({ deltaX }) {
      setWidth((prevWidth) => Math.max(280, prevWidth + deltaX));
    },
  });

  return (
    <div
      data-testid={testId}
      className={styles.sidebarPage}
      style={{ gridTemplateColumns: `${sidebarWidth}px 1fr` }}
    >
      <div
        ref={sidebarRef}
        className={styles.sidebar}
        aria-label="Resizable Sidebar"
        role="complementary"
      >
        <div
          className={clsx(styles.content, {
            [styles.table]: contentType === "table",
          })}
        >
          {sidebar}
        </div>
        <div
          {...moveProps}
          className={styles.resizeHandle}
          aria-label="Resize sidebar"
          role="separator"
        />
      </div>
      <div
        className={clsx(styles.body, {
          [styles.table]: contentType === "table",
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default SidebarPage;
